import Typography from "@/src/views/components/Typography";
import styles from "./index.module.scss";
import Mosaics1 from "@/src/views/components/Icon/icons/Mosaics1";
import PointLineTriangle1 from "@/src/views/components/Icon/icons/PointLineTriangle1";
import PointLineTriangle2 from "@/src/views/components/Icon/icons/PointLineTriangle2";
import { useEffect, useRef } from "react";

export default function LandingOverview({
  headline,
  listWordStyling,
}) {
  const square1Ref = useRef(null);
  const mosaics1Ref = useRef(null);
  const pointLineTriangle1Ref = useRef(null);
  const square2Ref = useRef(null);
  const pointLineTriangle2Ref = useRef(null);
  const heroSectionRef = useRef(null);
  const screenshotRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null, // use the viewport as the root
      rootMargin: '0px',
    };

    const callback: IntersectionObserverCallback = (
      entries: IntersectionObserverEntry[],
      observer: IntersectionObserver,
    ) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add(styles["visible"]);
          observer.unobserve(entry.target)
        }
      });
    };
    const observer = new IntersectionObserver(callback, options);
  
    if (square1Ref.current) {
      observer.observe(square1Ref.current);
    }
    if (mosaics1Ref.current) {
      observer.observe(mosaics1Ref.current);
    }
    if (pointLineTriangle1Ref.current) {
      observer.observe(pointLineTriangle1Ref.current);
    }
    if (square2Ref.current) {
      observer.observe(square2Ref.current);
    }
    if (pointLineTriangle2Ref.current) {
      observer.observe(pointLineTriangle2Ref.current);
    }
    if (heroSectionRef.current) {
      observer.observe(heroSectionRef.current);
    }
    if (screenshotRef.current) {
      observer.observe(screenshotRef.current);
    }
    // Clean up
    return () => {
      observer.disconnect();
    };
  }, [
    square1Ref,
    mosaics1Ref,
    pointLineTriangle1Ref,
    square2Ref,
    pointLineTriangle2Ref,
    heroSectionRef,
    screenshotRef,
  ]);

  return (
    <div
      id="landing-page-overview"
      className={styles["section-overview"]} 
    >
      <div className={styles["square-1-wrapper"]} ref={square1Ref}/>
      <Mosaics1 className={styles["mosaics-1-wrapper"]} svgRef={mosaics1Ref}/>
      <PointLineTriangle1 className={styles["point-line-triangle-1-wrapper"]} svgRef={pointLineTriangle1Ref}/>
      <div className={styles["square-2-wrapper"]} ref={square2Ref}/>
      <PointLineTriangle2 className={styles["point-line-triangle-2-wrapper"]} svgRef={pointLineTriangle2Ref}/>
      <div
        id="overview-hero-section"
        ref={heroSectionRef}
        className={styles["hero-section"]}
      >
        <img
          src={`${process.env.NEXT_PUBLIC_IMAGES}/bribrain-logo.svg`}
          height={"100px"}
          id="overview-bribrain-logo"
        />
        <Typography variant="title-2-medium" color="dark40" listWordStyling={listWordStyling}>
          {headline?.find(hl => hl.nama_headline === "bribrain")?.deskripsi_headline}
        </Typography>
      </div>
      <img
        ref={screenshotRef}
        className={styles["image-product-screenshot"]}
        src={`${process.env.NEXT_PUBLIC_IMAGES}/${headline?.find(hl => hl.nama_headline === "bribrain")?.thumbnail_headline}`}
      />
    </div>
  );
}
